<template>
	<not-found-content v-if="notFound"></not-found-content>
	<div class="page-content" v-else-if="page">
		<component v-for="(block, index) in page.blocks" :is="block.template" v-bind="block" :key="'block-' + block.id"></component>
	</div>
</template>

<script>
	import dataMixin from '../mixins/data';

	export default {
		mixins: [dataMixin],
		data() {
			return {
				url: '/json' + this.$route.fullPath
			};
		},
		computed: {
			page() {
				return this.$store.state.pageData;
			}
		},
		methods: {
			setSeo() {
				this.$setSeo({
					title: ((this.page.meta_title)?this.page.meta_title:this.page.name + ' | Pixelcore Development'),
					description: this.page.meta_description,
					keywords: this.page.meta_tags,
					image: (this.page.meta_image)?this.page.meta_image.link:'/images/front/logo-dark.png'
				});
			}
		}
	}
</script>